export const getSemDataTell = () => {
  var searchWord = route() || ' ';
  var data = {};
  data.site = getQueryString('site'); //自定义字段
  data.pn = getQueryString('pn'); //计划
  data.un = getQueryString('un'); //单元名
  data.pk = getQueryString('pk'); //关键词
  data.sw = searchWord; //搜索词
  return data;
};
// var searchWord = route() || ' ';
export const getQueryString = (name) => {
  var urlReg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(urlReg);
  if (r != null) {
    return decodeURI(r[2]);
  } else {
    return '';
  }
};

export const getQueryStringNoDecode = (name) => {
  var urlReg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(urlReg);
  if (r != null) {
    return r[2];
  } else {
    return '';
  }
};

export const getQueryStrings = (name, origin) => {
  var urlReg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = origin.substr(1).match(urlReg);
  if (r != null) {
    return decodeURI(r[2]);
  } else {
    return '';
  }
};

export const postSemData = () => {
  var data = {};
  data.plan_name = getQueryString('pn'); //计划
  data.unit_name = getQueryString('un'); //单元名
  data.bd_vid = getQueryString('bd_vid');
  data.search_terms = route() || ''; //搜索词
  data.platform_flag = IsPC(); //访问平台标识
  data.visit_time = +new Date(); //访问时间
  data.keywordid = getQueryString('e_keywordid'); //关键词id
  data.link_flag = window.location.href.split('?')[0];
  return data;
};

function getDomainQuery(url) {
  var d = [];
  var st = url.indexOf('//', 1);
  var _domain = url.substring(st + 1, url.length);
  var et = _domain.indexOf('/', 1);
  d.push(_domain.substring(1, et));
  d.push(_domain.substring(et + 1, url.length));
  return d;
}
function route() {
  var eg = [];
  eg.push(['baidu', 'word', 'word']);
  eg.push(['google', 'q', 'q']);
  eg.push(['soso', 'w', 'w']);
  eg.push(['yodao', 'q', 'q']);
  eg.push(['bing', 'q', 'q']);
  eg.push(['yahoo', 'q', 'q']);
  eg.push(['sogou', 'query', 'keyword']);
  //eg.push(['sogou', 'key']);//yd
  eg.push(['gougou', 'search', 'search']);
  eg.push(['360', 'q', 'q']); //360
  eg.push(['so', 'q', 'q']); //360
  eg.push(['sm', 'q', 'q']); //神马
  var dq = getDomainQuery(document.referrer);
  var keyword = null;
  // var grep = null;
  var str = null;

  for (var el in eg) {
    var s = eg[el];

    var DandQ = String(s).split(','); //字符分割
    if (dq[0].indexOf(DandQ[0]) > 0) {
      var reg1 = new RegExp('(^|&)' + DandQ[1] + '=([^&]*)(&|$)');
      if (dq[1].split('?')[1]) {
        str = dq[1].split('?')[1].match(reg1);
      }
      if (str == null) {
        var reg2 = new RegExp('(^|&)' + DandQ[2] + '=([^&]*)(&|$)');
        if (dq[1].split('?')[1]) {
          str = dq[1].split('?')[1].match(reg2);
        }
        if (str == null) {
          return '';
        }
      }
      str += '';

      keyword = str.split('=')[1].split('&')[0];
      keyword = decodeURIComponent(keyword);
      return keyword;
    }
  }
}
function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
  var flag = 'PC';
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = '移动';
      break;
    }
  }
  return flag;
}
